import ImgSpot from '../../components/ImgSpot/ImgSpot';
import SatzungListe from '../../components/SatzungListe/SatzungListe';
import './Satzung.css';
import img from '../../assets/VdHR©lisa_hinder_239.jpg';
import { useEffect } from 'react';

function Satzung() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div style={{ height: 'calc(100px + 16vh)' }}></div>
      <h1>Satzung</h1>

      <SatzungListe></SatzungListe>
      <ImgSpot img={img}></ImgSpot>
    </>
  );
}

export default Satzung;
